/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Message type for display through Bootstrap Alerts to the user
 */
export class MessageModel { 
    /**
     * Alert type mapping to the bootstrap alert css class: Info = 0, Warning = 1, Success = 2, Danger = 3
     */
    Alert?: MessageModel.AlertEnum;
    /**
     * Text to be displayed in the alert
     */
    Description?: string;
}
export namespace MessageModel {
    export type AlertEnum = 0 | 1 | 2 | 3;
    export const AlertEnum = {
        NUMBER_0: 0 as AlertEnum,
        NUMBER_1: 1 as AlertEnum,
        NUMBER_2: 2 as AlertEnum,
        NUMBER_3: 3 as AlertEnum
    };
}



// WEBPACK FOOTER //
// ./src/app/model/messageModel.ts